let html = `<div class="settings">
    <div class="settings__layer"></div>
    <div class="settings__content layer--height">
        <div class="settings__head">
            <div class="settings__title">#{title_settings}</div>
        </div>
        <div class="settings__body"></div>
    </div>
</div>`

export default html